<template>
  <div class="page">
    <div v-if="pipedrivestate == 0">
      <h2>Er is iets niet goed gegaan</h2>
      <p class="paragraph">
        We vragen je daarom vriendelijk het op een later tijdstip nogmaals te proberen
      </p>
    </div>
    <div v-if="pipedrivestate == 1">
      <h2>Bezig met verzenden van gegevens</h2>
    </div>
    <div v-if="pipedrivestate == 2">
      <h2>Bedankt voor je offerte aanvraag bij Huurdezon!</h2>
      <p class="paragraph">
        Een mooie eerste stap naar het duurzaam opwekken van jouw eigen stroom. 
        Onze adviseurs bekijken de resultaten en analyseren jouw specifieke situatie. 
        <br><br>
        Wij nemen binnen 2 werkdagen contact met je op voor een offerte op maat.
        Wil je alvast zelf een belafspraak inplannen op een moment dat het jou goed uitkomt? Dat kan!
      </p>
      <button v-if="pipedriveplannerurl" type="button" class="final" v-on:click="openPlanner()">Plan&nbsp;belafspraak</button><br><br>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'verbruikPage',
    mounted() {
      this.$store.dispatch('set_step_to', this.step)
      if( this.pipedrivestate < 2 )
        this.$store.dispatch('to_pipedrive')
    },
    data : function(){
      return{
        plannerurl : false,
        step : 4
      }
    },
    computed: {
      pipedrivestate() {
        return this.$store.getters.get_pipedrive_state
      },
      pipedriveplannerurl(){
        this.plannerurl = this.$store.getters.pipedrive_planner_url
        return this.plannerurl
      }
    },
    methods : {
      openPlanner : function(){
        let
          url = this.plannerurl,
          win = window.open(url, '_blank')
        win.focus()
      }
    },
  }
  // <router-link class="restart" to="/">Nogmaals aanvragen</router-link>
</script>

<style scoped lang="scss">
  button.final {
    max-width: 300px;
    border: 2px solid $color-primary;
    margin-top: 30px;
    padding: 15px 45px;
    font-size: 1.5em;
    font-weight: bold;
    color: $color-primary;
    background-color: $color-yellow-1;
    cursor: pointer;
    transition: all 350ms;

    &:focus, &:hover {
      color: white;
      background-color: $color-primary;
      box-shadow: 3px 3px 6px rgba(0,0,0,0.2);
      outline: 0;
      transition: all 350ms;
    }
  }
  .restart {
    &, &:active,&:link {
      max-width: 300px;
      border: 2px solid $color-primary;
      margin-top: 30px;
      padding: 15px 64px 15px 65px;
      font-size: 1em;
      text-decoration: none;
      text-align: center;
      color: $color-primary;
      background-color: $color-yellow-1;
      cursor: pointer;
      transition: all 350ms;
    }
    &:focus, &:hover {
      color: white;
      background-color: $color-primary;
      box-shadow: 3px 3px 6px rgba(0,0,0,0.2);
      outline: 0;
      transition: all 350ms;
    }
  }
</style>

